@if (extraInfo) {
  <div class="w-full flex flex-wrap items-center justify-end mb-8">
    <div class="p-3 border border-slate-300 rounded-xl flex items-center justify-center gap-2">
      <div class="text-zinc-900">Valor total:</div>
      <div class="text-zinc-900 font-semibold text-lg">{{ extraInfo.sum_value | currency }}</div>
    </div>
  </div>
}
<p-table
  [value]="items"
  [loading]="localLoading()"
>
  <ng-template #header>
    <tr>
      @for (column of columns; track $index) {
        <th
          [class]="column.align + ' text-sm'"
          [ngClass]="{ 'cursor-pointer': column.sortable }"
          (click)="column.sortable && sort(column.slug)"
        >
          {{ column.label }}
          @if (pageControl.orderField === column.slug) {
            @if (pageControl.order === order.ASC) {
              <i class="fa-solid fa-arrow-up"></i>
            }
            @if (pageControl.order === order.DESC) {
              <i class="fa-solid fa-arrow-down"></i>
            }
          }
        </th>
      }
    </tr>
  </ng-template>
  <ng-template #emptymessage>
    <tr>
      <td colspan="8" class="text-center">
        <div class="h-44 p-4 text-zinc-500">
          <ng-lottie [options]="emptyLottieOptions" />
          Nenhum registro encontrado.
        </div>
      </td>
    </tr>
  </ng-template>
  <ng-template #body let-item>
    <tr class="cursor-pointer" (click)="edit.emit(item)">
      <td>
        {{ item.created_at | date: 'dd/MM/y' }}<br>
        {{ item.created_at | date: 'HH:mm:ss' }}
      </td>

      <td>{{ item.nfse_key  || '---' }}</td>

      <td>{{ item.value  | currency }}</td>

      <td>{{ item.receiver?.name || '---' }}</td>

      <td>
        <div
          class="px-2 py-1 text-sm rounded-sm bg-gray-100 w-fit font-semibold"
          [ngClass]="{
            'text-amber-600': item.status === paymentStatus.PENDING_SOLICITATION,
            'text-rose-600': item.status === paymentStatus.REJECTED_SOLICITATION,
            'text-indigo-600': item.status === paymentStatus.PENDING_APPROVAL,
            'text-blue-600': item.status === paymentStatus.PENDING_PAYMENT,
            'text-emerald-600': item.status === paymentStatus.PAID,
            'text-red-600': item.status === paymentStatus.CANCELED,
            'text-sky-600': item.status === paymentStatus.PROCESSING_PAYMENT
          }"
        >
          {{ item.status | paymentStatus }}
        </div>
      </td>

      <td>
        {{ item.category?.title || '---' }}<br>
        <span class="text-sm">{{ item.subcategory?.title || '' }}</span>
      </td>

      <td>{{ item.due_date | date: 'dd/MM/y' }}</td>

      <td>{{ item.paid_at | date: 'dd/MM/y' }}</td>

      <td>
        <div class="flex items-center justify-start gap-1">
          <div
            class="cursor-pointer"
            pTooltip="Visualizar"
            tooltipPosition="bottom"
            (click)="edit.emit(item); $event.stopPropagation()"
          >
            <i class="fa-regular fa-eye"></i>
          </div>
          <div
            class="cursor-pointer"
            pTooltip="Fatura"
            tooltipPosition="bottom"
            (click)="openOutsideUrl(item.invoice_url); $event.stopPropagation()"
          >
            <i class="fa-solid fa-file-pdf"></i>
          </div>
        </div>
      </td>
    </tr>
  </ng-template>
 <ng-template #footer>
   <tr>
     <td colspan="8">
        <div class="w-full flex justify-end">
          <p-paginator
            (onPageChange)="onPageChange($event)"
            [rows]="pageControl.take"
            [totalRecords]="pageControl.itemCount"
            [showCurrentPageReport]="true"
            [rowsPerPageOptions]="[10, 25, 50]"
            currentPageReportTemplate="{first} - {last} de {totalRecords}"
            appendTo="body"
          />
        </div>
     </td>
   </tr>
 </ng-template>
</p-table>
